import { useTranslation as e } from "../../i18n.mjs";
import { isImageSelected as t } from "../image-extension/utils/is-image-selected.mjs";
import { toolbarActionItem as n } from "../../components/content-controls/toolbar-action-item.mjs";
import { PARAGRAPH_EXTRA_SPACING_ATTRIBUTE as r } from "./constants.mjs";
import { useEditorState as i } from "@tiptap/react";
import { useMemo as a } from "react";
import { jsx as o } from "react/jsx-runtime";
import { ParagraphSpacingIcon as s } from "@systemeio/icons";
//#region src/extensions/paragraph-extension/use-paragraph-space-extension.tsx
var c = (e) => e.attrs[r], l = (e, t, n) => {
	if (!e || t === void 0 || n === void 0) return !1;
	if (t === n) return e.isActive("paragraph");
	let r = !1;
	return e.state.doc.nodesBetween(t, n, (e) => {
		if (e.type.name === "paragraph") return r = !0, !1;
	}), r;
}, u = (e, t, n) => {
	if (!e || t === void 0 || n === void 0) return !1;
	if (t === n) {
		let n = e.state.doc.resolve(t);
		for (let e = n.depth; e >= 0; e--) {
			let t = n.node(e);
			if (t.type.name === "paragraph") return c(t);
		}
		return !1;
	}
	let r = !1;
	return e.state.doc.nodesBetween(t, n, (e) => {
		if (e.type.name === "paragraph") return r = c(e), !1;
	}), r;
}, d = (c, d) => {
	let { t: f } = e(), p = i({
		editor: c,
		selector: ({ editor: e }) => {
			let n = e?.state.selection.from, r = e?.state.selection.to;
			return {
				isEditable: e?.options.editable ?? !1,
				isImageSelected: t(e),
				hasParagraphContext: l(e, n, r),
				isActive: u(e, n, r)
			};
		}
	}), m = !p?.isEditable || !!p?.isImageSelected || !p?.hasParagraphContext, h = p?.isActive ?? !1;
	return a(() => {
		let e = f("extra_spacing");
		return n({
			active: h,
			disabled: m,
			icon: /* @__PURE__ */ o(s, {}),
			label: e,
			onClick: () => {
				c && c.chain().focus().updateAttributes("paragraph", { [r]: !h }).run();
			},
			tooltip: d ? null : e
		});
	}, [
		c,
		h,
		m,
		d,
		f
	]);
};
//#endregion
export { d as useParagraphSpaceExtensionToolbar };
